import React, { useRef, useState } from "react";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";

function QRCodePage() {
  const baseURL = `${window.location.protocol}//${window.location.host}`;
  const [value, setValue] = useState();
  const [qrValue, setQrValue] = useState(baseURL);

  const imgRef = useRef(null);

  const handleSaveAsPng = async () => {
    if (imgRef.current) {
      try {
        const dataUrl = await toPng(imgRef.current);
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "QRCode.png";
        link.click();
      } catch (error) {
        console.error("Failed to save as PNG", error);
      }
    }
  };
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">Qrcode Generator</h1>
          </div>
        </div>

        <div className="w-full">
          <form
            action=""
            className="w-full"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-1/3"></label>
              <label htmlFor="" className="w-full md:w-1/3">
                <span className="text-d-bg-text text-sm mb-2">Link </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Link"
                    onChange={(e) => setValue(e.target.value)}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <div htmlFor="" className="my-6">
              <div ref={imgRef}>
                <QRCode value={qrValue} className="mx-auto" />
              </div>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => {
                  setQrValue(value);
                }}
              >
                Update
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={handleSaveAsPng}
              >
                Download
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default QRCodePage;
